import SuccessImage from 'assets/images/tick-light.png';
import ButtonSymphony from 'elements/ButtonSymphony';
import PageSymphony from 'elements/PageSymphony';
import Sty from 'modules/Sty';
import { CSSProperties } from 'react';

interface PostCreationInfoViewProps {
    title?: string;
    description?: string;
    buttonLabel?: string;
    error?: boolean;
    handleClick?: () => void;
}

const PostCreationInfoView = ({
    title,
    description,
    buttonLabel,
    error,
    handleClick,
}: PostCreationInfoViewProps) => {
    return (
        <PageSymphony
            className="postCreationInfoViewComponent"
            isContent
            isCard
            maxWidth={600}
        >
            <div
                className="postCreationInfoInner"
                style={sty.postCreationInfoInner}
            >
                {!error && <img alt="tick-light.png" src={SuccessImage} />}
                <div className="postCreationInfoViewTitle" style={Sty.text20}>
                    {title}
                </div>
                <div className="postCreationInfoViewDescription" style={Sty.text16grey}>
                    {description}
                </div>
                <ButtonSymphony
                    className="postCreationInfoViewButtonFans"
                    onClick={handleClick}
                    style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 24 }}
                >
                    {buttonLabel || 'See Campaign Details'}
                </ButtonSymphony>
            </div>
        </PageSymphony>
    );
};

const sty: Record<string, CSSProperties> = {
    postCreationInfoInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    }
}
export default PostCreationInfoView;
